export default __webpack_public_path__ + "static/media/spark_70.bf3a9398.png";